var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14855 0 0 5.14855 0 11.5C0 17.8514 5.14855 23 11.5 23C17.8514 23 23 17.8514 23 11.5C23 5.14855 17.8514 0 11.5 0Z",
    fill: "#1873EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0566 14.5481H16.0328L16.5003 11.5247H13.0566V9.8722C13.0566 8.6164 13.4671 7.50262 14.6419 7.50262H16.5296V4.86452C16.1978 4.81967 15.4963 4.72192 14.1709 4.72192C11.4029 4.72192 9.78025 6.18357 9.78025 9.51397V11.5253H6.93457V14.5487H9.77967V22.8586C10.3432 22.9425 10.9141 23 11.5001 23C12.0296 23 12.5466 22.9517 13.0566 22.8827V14.5481Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.161e96217230ddf91efaaa6f11be48a6.svg";
export { ForwardRef as ReactComponent };